import content from '@/assets/data/content.json';

export default {
  loading: true,
  isInTransition: false,
  content,
  currentIndex: undefined,
  scrollIsLocked: true,
  currentPage: undefined,
  isInPage: false,
};
